import moment from 'moment-timezone';
import {
   PRODUCT_TYPE,
   WINNING_FARE,
   SEARCH_CRITERIA_CHECKBOX_CATEGORY,
   PRODUCT_TYPE_C_AND_I,
   PRODUCT_TYPE_C,
   PRODUCT_TYPE_I,
   WINNING_FARES,
} from '../../../../utils/constants';
import { DateUtil } from '../../../../utils/date-util.js';

export function replaceKeyAndRemoveField(obj) {
   Object.values(obj).forEach((arr) => {
      if (Array.isArray(arr)) {
         arr.forEach((item) => {
            if (item.field) {
               item.key = item.field;
               delete item.field;
            }
         });
      }
   });
   return obj;
}

export function updateSelectedCheckboxes(prevSelected, key, value) {
   const updatedSelection = new Set(prevSelected);
   if (value) {
      updatedSelection.add(key);
   } else {
      updatedSelection.delete(key);
   }
   return updatedSelection;
}

export function getUpdatedConfig(selectedCheckboxes, searchCriteriaData) {
   const selectedKeysArray = Array.from(selectedCheckboxes);

   return searchCriteriaData.map((item) => ({
      ...item,
      config: item.config.filter(
         (section) =>
            !section.isConfinedTo ||
            section.isConfinedTo.some((confinedKey) =>
               selectedKeysArray.includes(confinedKey)
            )
      ),
   }));
}

export function generateConstructedPayload(searchCriteriaData) {
   const payload = {};
   Object.entries(searchCriteriaData).forEach(([key, searchData]) => {
      let isConstructedFareEnabled = false;
      let isSpecifiedFareEnabled = false;
      let isWinningFare = false;
      const searchValues = searchData.filter((record) => record.value);
      if (searchValues.length > 0) {
         searchValues.forEach((productDetails) => {
            if (productDetails.key === PRODUCT_TYPE.CONSTRUCTED)
               isConstructedFareEnabled = true;
            else if (productDetails.key === PRODUCT_TYPE.SPECIFIED)
               isSpecifiedFareEnabled = true;
            else if (productDetails.key === WINNING_FARE) isWinningFare = true;
         });
         if (isConstructedFareEnabled && isSpecifiedFareEnabled)
            payload[key] = 'C,I';
         else if (isConstructedFareEnabled && !isSpecifiedFareEnabled)
            payload[key] = 'C';
         else if (isWinningFare) payload[key] = { [WINNING_FARE]: true };
         else if (isSpecifiedFareEnabled && !isConstructedFareEnabled)
            payload[key] = 'I';
         else if (
            !isSpecifiedFareEnabled &&
            payload[key] !== SEARCH_CRITERIA_CHECKBOX_CATEGORY.PRODUCT_TYPE
         ) {
            payload[key] = searchValues;
         }
      }
   });
   return payload;
}

export function toggleWinningFareCheckBox(searchCriteriaConfig, isDisable) {
   searchCriteriaConfig[0].config.map((record) =>
      record.fields.map((category) => {
         if (category.field === WINNING_FARE) category.disabled = !isDisable;
         return category;
      })
   );
   return searchCriteriaConfig;
}

export function findConstructedAndSpecifiedStatus(payload) {
   let isConstructedFare = false;
   let isSpecifiedFare = false;
   Object.values(payload).forEach((record) =>
      record.forEach((category) => {
         if (category.key === PRODUCT_TYPE.CONSTRUCTED && category.value)
            isConstructedFare = true;
         else if (category.key === PRODUCT_TYPE.SPECIFIED && category.value)
            isSpecifiedFare = true;
      })
   );

   return { isConstructedFare, isSpecifiedFare };
}
const removeNullValues = (searchData) => {
   return searchData.filter((record) => record.value.length > 0);
};

export const generateSpecifiedPayload = (payload) => {
   const requestPayload = {};
   Object.entries(payload).forEach(([key, searchData]) => {
      if (
         key !== SEARCH_CRITERIA_CHECKBOX_CATEGORY.PRODUCT_TYPE &&
         key !== SEARCH_CRITERIA_CHECKBOX_CATEGORY.TABLE
      ) {
         requestPayload[key] = searchData;
      } else if (key === SEARCH_CRITERIA_CHECKBOX_CATEGORY.PRODUCT_TYPE) {
         const data = searchData.filter((record) => record.value);
         if (data.length > 0) {
            const isSpecified = data.some(
               (productDetails) => productDetails.key === PRODUCT_TYPE.SPECIFIED
            );
            if (isSpecified) requestPayload[key] = 'I';
         }
      }
   });
   return requestPayload;
};

export const initialState = () => {
   return {
      productType: [
         {
            operator: '=',
            field: 'specified',
            key: 'Spec',
            value: true,
         },
      ],
   };
};

export const getCheckBoxSelectionDetails = (searchData) => {
   switch (searchData) {
      case 'C,I':
         return PRODUCT_TYPE_C_AND_I;
      case 'C':
         return PRODUCT_TYPE_C;
      case 'I':
         return PRODUCT_TYPE_I;
      case 'W':
         return WINNING_FARES;
   }
};

export const INPUT_TYPE = {
   TEXT: 'text',
   DATE_PICKER: 'datePicker',
   MULTI_SELECT: 'multiSelect',
   CHECK_BOX: 'checkBox',
   RADIO_BUTTON: 'radioButton',
};

export const removeEmptyFields = (payload) => {
   const validPayload = {};
   Object.entries(payload).forEach(([key, searchData]) => {
      if (
         key !== SEARCH_CRITERIA_CHECKBOX_CATEGORY.PRODUCT_TYPE &&
         key !== SEARCH_CRITERIA_CHECKBOX_CATEGORY.TABLE
      ) {
         const validData = removeNullValues(searchData);
         if (validData.length > 0) validPayload[key] = validData;
      } else {
         validPayload[key] = searchData;
      }
   });
   return validPayload;
};

export const validateReceivedDateFormat = (date) => {
   return moment(date, DateUtil.DATE_FORMATS.DD_MMM_YY_TIME, true).isValid();
};
